import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

export interface ClockOutScheduleWarningDialogData {
  scheduled_exit_time: string;
  current_time: string;
}

export type ClockOutScheduleWarningDialogResult = 'clock-out' | 'manage-exception' | false;

@Component({
  selector: 'app-clock-out-schedule-warning-dialog',
  templateUrl: './clock-out-schedule-warning-dialog.component.html',
  styleUrl: './clock-out-schedule-warning-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatIcon],
})
export class ClockOutScheduleWarningDialogComponent {
  readonly dialog_ref = inject(MatDialogRef<ClockOutScheduleWarningDialogComponent, ClockOutScheduleWarningDialogResult>);
  readonly data = inject<ClockOutScheduleWarningDialogData>(MAT_DIALOG_DATA);

  confirmClockOut(): void {
    this.dialog_ref.close('clock-out');
  }

  manageException(): void {
    this.dialog_ref.close('manage-exception');
  }
}
